import { OrderState } from 'app/order/models/order-state.model';
import { differenceInYears, parse } from 'date-fns';
import { Title, TitleDto } from './title';

// #region interfaces

export interface Customer {
    readonly id: number;
    title: Title;
    company: string;
    firstName: string;
    lastName: string;
    fullName: string;
    street: string;
    zip: string;
    city: string;
    phone: string;
    dateOfBirth: string;
    mail: string;
}

export interface CustomerDto {
    Id: number;
    Title: TitleDto;
    Company: string;
    Firstname: string;
    Lastname: string;
    Street: string;
    ZIP: string;
    City: string;
    Phone: string;
    DateOfBirth: string;
    Email: string;
}

export interface LockersNetCustomerDto {
    readonly Id: number;
    Company: string | null;
    Name: string | null;
    Street: string | null;
    ZIP: string | null;
    City: string | null;
    Email: string | null;
    Phone: string | null;
    DateOfBirth: string | null;
}
// #endregion

// #region mappers

export function dtoToCustomer(dto: CustomerDto): Customer {
    return {
        id: dto.Id,
        title: {
            id: dto.Title.Id,
            description: dto.Title.Description,
        },
        firstName: dto.Firstname,
        lastName: dto.Lastname,
        fullName: `${dto.Firstname ? dto.Firstname + ' ' : ''}${dto.Lastname}`,
        company: dto.Company,
        street: dto.Street,
        zip: dto.ZIP,
        city: dto.City,
        phone: dto.Phone,
        mail: dto.Email,
        dateOfBirth: dto.DateOfBirth,
    };
}

export function customerToOrderState(customer: Customer): Pick<OrderState, 'billingAddress'> {
    return {
        billingAddress: {
            title: customer.title,
            firstName: customer.firstName,
            lastName: customer.lastName,
            company: customer.company,
            street: customer.street,
            zip: customer.zip,
            city: customer.city,
            phone: customer.phone,
            mail: customer.mail,
            dateOfBirth: customer.dateOfBirth,
        },
    };
}

export function lnDtoToOrderState(dto: LockersNetCustomerDto): Partial<OrderState> {
    const [lastName, firstName] = dto.Name.split(',').map((item) => item.trim());
    const over18: boolean = differenceInYears(new Date(), parse(dto.DateOfBirth, 'dd.MM.yyyy', new Date())) >= 18;

    const state = {
        billingAddress: {
            firstName: over18 ? firstName : '',
            lastName: over18 ? lastName : '',
            dateOfBirth: over18 ? dto.DateOfBirth : null,
            street: dto.Street,
            zip: dto.ZIP,
            city: dto.City,
            phone: dto.Phone,
            mail: dto.Email,
        },
        insurants: over18
            ? []
            : [
                  {
                      firstName,
                      lastName,
                      dateOfBirth: dto.DateOfBirth,
                      isInsuree: false,
                      isChild: true,
                  },
              ],
    } as OrderState;

    return state;
}

export function customerToDto(customer: Customer): CustomerDto {
    return {
        Id: customer.id,
        Title: {
            Id: customer.title.id,
            Description: customer.title.description,
        },
        Company: customer.company,
        Firstname: customer.firstName,
        Lastname: customer.lastName,
        Street: customer.street,
        ZIP: customer.zip,
        City: customer.city,
        Phone: customer.phone,
        DateOfBirth: customer.dateOfBirth,
        Email: customer.mail,
    };
}

// #endregion
